import {
  setGlobalFilter,
  setNewFunnelUrlPattern,
  setNewHeatmapUrlPattern,
  setRecordingsOverviewPageUrlFilterValue,
} from '@va/dashboard/actions/ui';
import { getWebsite, getWebsiteTimezone } from '@va/dashboard/selectors/core';
import { T3_URL_PARAMS } from '@va/standalone/shared/constants';
import { getGlobalFilterFromUrl, getParameterByName } from '@va/util/helpers';
import { put, select } from 'redux-saga/effects';

export function* parseT3QueryParamsSaga() {
  const newFunnelUrlPattern = getParameterByName(T3_URL_PARAMS.newFunnelUrl);
  const newHeatmapUrlPattern = getParameterByName(T3_URL_PARAMS.newHeatmapUrl);
  const recordingsOverviewPageUrl = getParameterByName(T3_URL_PARAMS.recordingsOverviewPageUrl);

  const timezone: string = yield select(getWebsiteTimezone);
  const website: { installDate?: number } = yield select(getWebsite);
  const urlFilter = getGlobalFilterFromUrl(timezone, website.installDate);

  if (urlFilter) {
    yield put(setGlobalFilter(urlFilter));
  }

  if (recordingsOverviewPageUrl) {
    yield put(setRecordingsOverviewPageUrlFilterValue(recordingsOverviewPageUrl));
  }

  if (newHeatmapUrlPattern) {
    yield put(setNewHeatmapUrlPattern(newHeatmapUrlPattern));
  }

  if (newFunnelUrlPattern) {
    yield put(setNewFunnelUrlPattern(newFunnelUrlPattern));
  }
}
